var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(data){return [_vm._t(name,null,null,data)]}}})],null,true)},'v-tabs',_vm.extendAttrs,false),_vm.extendListeners),[_vm._l((_vm.$slots),function(_,name){return _c('template',{slot:name},[_vm._t(name)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }